let countdown = (actionData) => {
    window.Smart.countdown.start(actionData.selector, actionData.seconds)
};

export default countdown;
